import { newsHero, categories } from '@/mocks/newsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

interface Props {
  activeCategory: string;
  onCategoryChange: (key: string) => void;
}

export default function NewsHero({ activeCategory, onCategoryChange }: Props) {
  return (
    <section className="relative w-full">
      <div className="relative h-[420px] md:h-[560px] overflow-hidden">
        <div className="absolute inset-0 bg-brand-deep">
          <div className="absolute inset-0 opacity-20">
            <img
              src={readdy('news-hero-bg-v3')}
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
          <ScrollReveal variant="fade-down">
            <p className="text-brand-gold/60 text-xs tracking-[0.3em] mb-4 font-medium uppercase">
              {newsHero.subtitle}
            </p>
          </ScrollReveal>
          <ScrollReveal variant="fade-up" delay={100}>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              {newsHero.title}
            </h1>
          </ScrollReveal>
          <ScrollReveal variant="fade-up" delay={200}>
            <p className="text-white/50 text-sm md:text-base max-w-lg leading-relaxed">
              {newsHero.description}
            </p>
          </ScrollReveal>
        </div>
      </div>

      <div className="bg-white border-b border-gray-100">
        <div className="px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-1 md:gap-2 overflow-x-auto py-4 md:justify-center">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  onClick={() => onCategoryChange(cat.key)}
                  className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeCategory === cat.key
                      ? 'bg-brand-deep text-white'
                      : 'text-gray-500 hover:text-brand-deep hover:bg-brand-gray'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}